import { useRef, useState } from "react"
import tw from "twin.macro"
import FilterTitle from "./FilterTitle"
import AnimatedChevron from "../../atoms/Accordion/AnimatedChevron"

interface ReusableFilterProps {
  title: string
  initialExpanded?: boolean
  showCount?: boolean
  countValue?: number | null
  children: React.ReactNode
}
const ReusableFilter: React.FC<ReusableFilterProps> = ({
  title,
  initialExpanded = false,
  showCount = false,
  countValue = null,
  children,
}) => {
  const content = useRef(null)
  const [isExpanded, setIsExpanded] = useState(initialExpanded)
  const elementRef = useRef(null)

  return (
    <section css={[tw`w-full border-b border-gray-200 py-4`]} ref={elementRef}>
      <button
        type="button"
        css={[
          tw`flex justify-between items-center w-full`,
          tw`focus-visible:(outline-gray-50)`,
          "-webkit-tap-highlight-color: transparent;",
        ]}
        aria-expanded={isExpanded}
        onClick={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        <FilterTitle
          title={title}
          isExpanded={isExpanded}
          count={countValue}
          showCount={showCount}
        />
        <AnimatedChevron isExpanded={isExpanded} />
      </button>

      {isExpanded && (
        <div css={[tw`max-w-[96%] md:max-w-[94%]`]} ref={content}>
          {children}
        </div>
      )}
    </section>
  )
}
export default ReusableFilter
